<template>
  <div class="sale-prompt">
    <div style="margin-bottom:0.8rem">
      <el-button @click="addPrompt" size="small" type="success" icon="el-icon-plus">添加提示</el-button>
      <el-button :loading="pointLoading" size="small" @click="savePoint" type="primary">保存</el-button>
    </div>
    <div v-for="(msg,index) in promptData" :key="index" class="save-box">
      <div class="sale-prompt-input">
        <span class="trend-title">销售提示数据</span>
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button @click="removePrompt(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
      <div class="sale-prompt-input">
        <span class="trend-title">提示时间</span>
        <el-date-picker
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="msg.noteTime"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </div>
      <div class="sale-prompt-input">
        <span class="trend-title">事件类型</span>
        <el-select v-model="msg.eventType" placeholder="请选择">
          <el-option
            v-for="item in thingType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="sale-prompt-input">
        <span class="trend-title">事件主体</span>
        <el-input type="text" placeholder="请输入" v-model="msg.eventBody"></el-input>
      </div>
      <div class="sale-prompt-input">
        <span class="trend-title">发生区域</span>
        <el-input type="text" placeholder="请输入" v-model="msg.eventArea"></el-input>
      </div>
      <div class="sale-prompt-input">
        <span class="trend-title">事件内容</span>
        <el-input type="text" placeholder="请输入" v-model="msg.eventContent"></el-input>
      </div>
    </div>
    <!-- <div class="last-save">
      
    </div> -->
  </div>
</template>

<script>
import api from '@/apis/sale/sale'
export default {
  data(){
    return{
      pointLoading:false,//加载状态
      options: [{
        value: 0,
        label: '从后台获取'
      }, {
        value: 1,
        label: '手工录入'
      }],
      thingType: [
        {
          value: 1,
          label: '安全提示'
        }, 
        {
          value: 2,
          label: '管理提示'
        },
        {
          value: 3,
          label: '能耗突增'
        },
        {
          value: 4,
          label: '能耗超标'
        },
      ],
      value:1,//获取数据方式

      promptData:[
        {noteTime:'',eventType:'',eventBody:'',eventArea:'',eventContent:''}
      ]
    }
  },
  mounted(){
    this.getPoint()
  },
  methods:{
    //保存数据
    savePoint(){
      this.pointLoading = true;
      api.saveNotify(this.promptData).then(res=>{
        if(res.code==10000){
          this.pointLoading = false;
          this.getPoint()
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message);
          this.pointLoading = false;
          return;
        }
      })
    },
    //获取数据
    getPoint(){
      api.getNotify().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.promptData = res.data.list
          }
        }
      })
    },
    //删除一行销售提示
    removePrompt(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delNotify([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getPoint()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.promptData.splice(index,1)
      }
    },
    //添加一行销售提示
    addPrompt(){
      this.promptData.unshift({noteTime:'',eventType:'',eventBody:'',eventArea:'',eventContent:''})
    },
  }
}
</script>
<style lang="less" scoped>
.sale-prompt{padding-top: 10px;
  .save-box{ display:inline-block; border: #3570ff solid 1px; position: relative; width: 30%; padding:1rem; margin-right:1rem; margin-bottom: 1rem; position: relative;
    .sale-prompt-input{ display: flex; flex-direction: row; margin-bottom: 15px;
      .trend-title{ flex-shrink: 0; width: 7rem;}
      .el-input,.el-select{ width: 100%;}
    }
  }
}
</style>